import { ReactNode, isValidElement, Children } from 'react';
import { isEqual } from 'lodash'; // 使用深比较库

// 递归比较两个 ReactNode 是否相等
export function areChildrenEqual(
    oldChildren: ReactNode,
    newChildren: ReactNode
): boolean {
    // 1. 处理 null/undefined 的边界情况
    if (oldChildren == null || newChildren == null) {
        return oldChildren === newChildren; // 只有同为 null 或同为 undefined 时返回 true
    }

    // 2. 转换为数组处理
    const oldArray = Children.toArray(oldChildren);
    const newArray = Children.toArray(newChildren);

    // 3. 数组长度不同直接返回 false
    if (oldArray.length !== newArray.length) return false;

    // 4. 遍历比较每个子元素
    return oldArray.every((oldChild, index) => {
        const newChild = newArray[index];

        // 处理基本类型（string/number/boolean）
        if (!isValidElement(oldChild) || !isValidElement(newChild)) {
            return Object.is(oldChild, newChild); // 使用 Object.is 处理 NaN 等特殊值
        }

        // 比较 ReactElement 的关键标识
        if (oldChild.type !== newChild.type || oldChild.key !== newChild.key) {
            return false;
        }

        // 递归比较 props（包含子元素）
        return arePropsEqual(oldChild.props, newChild.props);
    });
}

// 比较 props 对象（包含递归处理 children）
function arePropsEqual(oldProps: object, newProps: object): boolean {
    // 类型断言处理 children
    const oldChildren = (oldProps as { children?: ReactNode }).children;
    const newChildren = (newProps as { children?: ReactNode }).children;

    // 递归比较 children
    if (!areChildrenEqual(oldChildren, newChildren)) return false;

    // 提取非 children 属性进行比较
    const { children: _old, ...oldRest } = oldProps as { children?: ReactNode };
    const { children: _new, ...newRest } = newProps as { children?: ReactNode };

    return isEqual(oldRest, newRest);
}